import React from 'react'
import { Helmet } from 'react-helmet';

import Menu from './sub_components/Menu.js'
import BinaryBG from './sub_components/BinaryBG.js'
import CyclingText from './sub_components/CyclingText.js'

import one_line_adam from '../images/me_one_line.png'
import one_line_chewy from '../images/chewy_one_line.png'
import github from '../images/icons/github.png'
import linkedIn from '../images/icons/linkedIn.png'

import './sub_components/pointer.js'

import '../stylesheets/HomeSS.css'

function Home() {

  let pg_1_wordsMain = ["learn.", "understand.", "improve.", "drink coffee?"];
  let pg_1_text = "A blog to ";

  let ak_styleObj = {
    parent: {

    },
    text: {
      zIndex:"-1"
    },
    child: {
      top: '0',
      left: '5%',
      zIndex:"-1"
    }
  }
  let chewy_styleObj = {
    parent: {

    },
    text: {
      zIndex:"-1"
    },
    child: {
      top: '0',
      left: '-5%',
      zIndex:"-1"
    }
  }
  let icon_linkedIn = {
    position:"absolute",
    top:"90vh",
    left: "40px",
    width:'48px',
    height:'48px'
  }
  let icon_github = {
    position:"absolute",
    top:"90vh",
    left: "92px",
    width:'48px',
    height:'48px'
  }
  function linkOpen(e){
    let targetLink = e.target.alt;
    if(targetLink === "linkedIn"){
      //to linkedIn
      window.open("https://www.linkedin.com/in/adam-kaminski-51b06a234", "__blank","noopener,noreferrer");
    }else if(targetLink === "Github"){
      //to github
      window.open("https://github.com/AdamKamZA", "__blank","noopener,noreferrer");
    }
  }

  return (
    <div id='pg_1'>
      <Helmet>
        <meta name="description" content="A software development blog to learn and improve coding, algorithm and tool skills" data-react-helmet="true"/>
        <meta name="keywords" content="Web Android C# Java NodeJS Data Python Github JavaScript" data-react-helmet="true"/>
        <meta name="author" content="Adam Kaminski" data-react-helmet="true"/>
        <meta name="title" content="Software development blog" data-react-helmet="true"/>
      </Helmet>
      <div id='menu_container'>
        <Menu></Menu>
      </div>
      <section id='content_text_image'>
        <CyclingText text={pg_1_text} wordArr={pg_1_wordsMain}></CyclingText>
        <section id='bg_img'>
          <BinaryBG img={one_line_adam} cName='ak' styleObj={ak_styleObj}></BinaryBG>
          <BinaryBG img={one_line_chewy} cName='ch' styleObj={chewy_styleObj}></BinaryBG>
        </section>
      </section>
      <div id='c_circle_1'></div>
      <div id='c_circle_2'></div>
      <img src={linkedIn} alt='linkedIn' className = 'portfolio' style={icon_linkedIn} onClick={linkOpen}></img>
      <img src={github} alt='Github' className = 'portfolio' style={icon_github} onClick={linkOpen}></img>
    </div>
  )
}

export default Home
